module.exports = __webpack_public_path__ + "static/media/gem2.4e450f2a.png";